import script from "./LoginS.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__